import { render, staticRenderFns } from "./itemSpan.vue?vue&type=template&id=3e8e3ac4&scoped=true"
import script from "./itemSpan.vue?vue&type=script&lang=js"
export * from "./itemSpan.vue?vue&type=script&lang=js"
import style0 from "./itemSpan.vue?vue&type=style&index=0&id=3e8e3ac4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e3ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8e3ac4')) {
      api.createRecord('3e8e3ac4', component.options)
    } else {
      api.reload('3e8e3ac4', component.options)
    }
    module.hot.accept("./itemSpan.vue?vue&type=template&id=3e8e3ac4&scoped=true", function () {
      api.rerender('3e8e3ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabCalendarSpan/components/itemSpan.vue"
export default component.exports